module.exports = "https://web-assets.ifttt.com/packs/media/subscriptions/ifttt_10ypromo_success_header-5a6fb16b.jpg";